import {
  useProductOptions,
  parseMetafield,
  ProductPrice,
  AddToCartButton,
  BuyNowButton,
  ProductOptionsProvider,
  Link,
  Image,
  CartProvider,
  useCart,
} from '@shopify/hydrogen';
import Gallery from './Gallery.client';
import gifts from '../assets/image/gifts.svg';
import iconEbook from '../assets/image/icons/icon-ebook.svg';
import delivery from '../assets/image/delivery.svg';
import ProductDetailsInfo from './ProductDetailsInfo.client';
import {useEffect, useState} from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import {changeGTSymbol} from '../lib/functions';
import {useCartUI} from './CartUIProvider.client';
import SpinnerIcon from './SpinnerIcon.client';
import ButtonWs from './whatsapp/ButtonWs.client';
import StarsFront from './shared/starts-front.client';
import HeroCarousel from './carousel/HeroCarousel.client';
import {encriptUrlData, getBaseUrl, getPropertiesImage, roundDownToNearestTen} from '../lib/Utils';
import profileDummy from '../assets/image/image-profile.png';
import excerptButton from '../assets/image/excerpt-icon-2.png';
import ModalVideo from 'react-modal-video';
import playButton from '../assets/image/playButton.png';
import {sendEvent} from '../lib/analitycs';
import SimpleModal from './modal/SimpleModal';
import { useMetaAPI } from '../hooks/useMetaAPI';
import PDFViewer from './others/pdfviewer.client';
import { GLOBAL_VARS } from '../lib/globalvars';
import { sendPulseEvent } from '../services/dru-id/pulse.client';
import { loginDruId } from '../lib/druid';
import ClubHLMLogo from '../assets/image/clubhlm/clubhlm-logo-badge.svg';


function AddToCartMarkup({customerAccessToken, product, sanityData}) {
  const {selectedVariant} = useProductOptions();
  const isOutOfStock = !selectedVariant.availableForSale;
  const {openCart} = useCartUI();
  const [isLoading, setIsLoading] = useState(false);
  const {checkoutUrl, status, lines, cartCeate, linesAdd} = useCart();
  const all = useCart();
  const [isEbook, setIsEbook] = useState(false);
  const [isClubHLM, setIsClubHLM] = useState(false);
  const [authCLubHLM, setAuthCLubHLM] = useState({});
  const {conversion} = useMetaAPI();

  const getCoupon = () => {
    const discountCodes = all?.discountCodes ? all?.discountCodes : [];
    let coupon = '';

    if (discountCodes.length > 0) {
      coupon = discountCodes.map((item) => {
        return item.code;
      });

      return coupon.join(',');
    } else {
      return '';
    }
  };

  const getPrice = (selectedVariant) => {
    const price = selectedVariant.priceV2.amount;
    const priceWithDiscount = selectedVariant.compareAtPriceV2?.amount;
    return priceWithDiscount == 0 ? price : priceWithDiscount;
  };
  
  //console.log('variant id' + selectedVariant.id);
  const handleCustomOnClick = (event) => {
    dataLayer.push({
      event: 'add_to_cart', //Static data
      currency: 'MXN', //Dynamic data
      value: selectedVariant.priceV2.amount, //Dynamic data
      items: '', //Dynamic data
      item_id: selectedVariant.id, //Dynamic data
      item_name: selectedVariant.title, //Dynamic data
      affiliation: '', //Dynamic data
      coupon: '', //Dynamic data
      discount: '', //Dynamic data
      index: '', //Dynamic data
      item_brand: '', //Dynamic data
      item_category: '', //Dynamic data
      item_category2: '', //Dynamic data
      item_category3: '', //Dynamic data
      item_category4: '', //Dynamic data
      item_list_id: '', //Dynamic data
      item_list_name: '', //Dynamic data
      item_variant: '', //Dynamic data
      location_id: '', //Dynamic data
      price: selectedVariant.priceV2.amount, //Dynamic data
      quantity: '1', //Dynamic data
      buy_now: 'FALSE', //Dynamic data
      item_tag: '', //Dynamic data
      item_tag2: '', //Dynamic data
      item_tag3: '', //Dynamic data
      item_tag4: '', //Dynamic data
    });
    
    GLOBAL_VARS.CART.lastProductSelected = product?.variants?.nodes[0].id;


    conversion({
      event: 'addToCart',
      contentIds: selectedVariant.id,
      content_type: 'product',
      value: getPrice(selectedVariant),
      currency: 'MXN',
      content_name: selectedVariant.title,
      content_category: '',
      cliend_user_agent: navigator.userAgent,
      action_source: 'website',
      event_time: Math.floor(Date.now() / 1000),
      eventSource: document.URL,
      price: getPrice(selectedVariant),
    });


    sendPulseEvent('addProducCart', {
      "originDisplayName": "pagina producto",
      "objectDisplayName": sanityData?.store.title,
      "targetDisplayName": "carrito",
      "product": product,
      "sanityData": sanityData
    });

    setIsLoading(true);
    setTimeout(() => {
      openCart();
      setIsLoading(false);
      localStorage.setItem('isCartUpdateKey', Math.random(0, 1));
    }, 2000);
  };

  const handleOnClickDataLayer = (selectedVariant) => {
    //console.log('dataLayer', dataLayer, selectedVariant);
    dataLayer.push({
      event: 'begin_checkout', //Static data
      currency: 'MXN', //Dynamic data
      value: getPrice(selectedVariant), //Dynamic data
      items: '',
      item_id: selectedVariant.id, //Dynamic data
      item_name: selectedVariant.title, //Dynamic data
      coupon: getCoupon(), //Dynamic data
      price: getPrice(selectedVariant), //Dynamic data
      quantity: '1', //Dynamic data
    });
  };

  const checkIfIsEbook = async (merchandise) => {
    const data = await fetch(
      `https://ellibrero.myshopify.com/api/2021-04/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-shopify-storefront-access-token':'08d65afd1c45cce28156c380662775c7',
        },
        body: JSON.stringify({
          query: QUERY_PRODUCT,
          variables: {
            id: product.id,
          },
        }),
      },
    )
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          return res.body.json();
        }
      })
      .catch((error) => {
        return {
          error: error.toString(),
        };
      });
    const checkedIfEbook =
      data?.data?.product?.productType.toLowerCase() == 'ebooks' ? true : false;
    if (!customerAccessToken) {
      if (checkedIfEbook) {
        localStorage.setItem('hasEbookFromCartNotLogin', true);
        localStorage.setItem(
          'hasEbookFromCartNotLoginCheckoutURL',
          checkoutUrl,
        );
      }
    }
    setIsEbook(checkedIfEbook);
    return checkedIfEbook;
  };

  const QUERY_PRODUCT = `
query Product($id: ID!) {
  product(id: $id) {
    id
    title
    handle
    description
    descriptionHtml
    productType
    vendor
    tags
  }
}`;

  const handleGoToLogin = (variantsId) => {
    linesAdd([{merchandiseId: variantsId, quantity: 1}]);
    localStorage.setItem('hasEbookFromCartNotLogin', true);
    localStorage.setItem('hasEbookFromCartNotLoginCheckoutURL', checkoutUrl);
    const timeout = setTimeout(() => {
      // window.location.href = '/account/ebook/login';
      window.location.href = loginDruId();
    }, 1000);

    return () => clearTimeout(timeout);
  };

  const openPdf = () => {};

  useEffect(() => {
    checkIfIsEbook(selectedVariant);
  }, []);

  useEffect(() => {
    const buyNowButton = document.querySelector('.buyNowButton');
    if (buyNowButton) {
      document.querySelector('.buyNowButton').addEventListener('click', () => {
        handleOnClickDataLayer(selectedVariant);
      });
    }
  }, [selectedVariant]);

  useEffect(() => {
    const authCLubHLMLocal = JSON.parse(localStorage.getItem('authClubHLM'));
    if (authCLubHLMLocal?.success) {
      setIsClubHLM(true);
      setAuthCLubHLM(authCLubHLMLocal);
    }
  }, []);

  return (
    <>
      <CartProvider>
        <div className="fixed-mobile-btn pb-5 flex gap-5 xs:px-3 items-center  ">
          <AddToCartButton
            variantId={selectedVariant.id}
            quantity={1}
            onClick={handleCustomOnClick}
            className={`btn-main  text-white rounded-full hover:bg-purple-125 hover:shadow
              ${
                isLoading
                  ? 'bg-gray-300 disabled hover:bg-gray-220'
                  : 'bg-purple-120'
              }
            `}
            disabled={isOutOfStock}
          >
            {isLoading ? (
              <div className="w-5 h-5 mx-auto btn-spinner">
                <SpinnerIcon className="w-1 h-1" />
              </div>
            ) : isOutOfStock ? (
              'Producto sin inventario'
            ) : (
              'Agregar a mi bolsa'
            )}
          </AddToCartButton>
          {isOutOfStock ? (
            <p className="text-black text-center hidden"></p>
          ) : isEbook && !customerAccessToken ? (
            <>
              {!isClubHLM && (
                <button
                  onClick={() => handleGoToLogin(selectedVariant.id)}
                  className="btn-main btn-secondary"
                >
                  Comprar ahora
                </button>
              )}
            </>
          ) : (
            <>
              {!isClubHLM && (
                <BuyNowButton
                  variantId={selectedVariant.id}
                  className="btn-secondary buyNowButton xs:w-full"
                  datalayer-data={JSON.stringify(selectedVariant)}
                  datalayer-eventtype={'purchase'}
                >
                  Comprar ahora
                </BuyNowButton>
              )}
            </>
          )}
        </div>
      </CartProvider>
    </>
  );
}

function SizeChart() {
  return (
    <>
      <h3
        className="text-xl text-black font-semibold mt-8 mb-4"
        id="size-chart"
      >
        Size Chart
      </h3>
      <table className="min-w-full table-fixed text-sm text-center bg-white">
        <thead>
          <tr className="bg-black text-white">
            <th className="w-1/4 py-2 px-4 font-normal">Board Size</th>
            <th className="w-1/4 py-2 px-4 font-normal">154</th>
            <th className="w-1/4 py-2 px-4 font-normal">158</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-3 border border-black">Weight Range</td>
            <td className="p-3 border border-black">120-180 lbs. /54-82kg</td>
            <td className="p-3 border border-black">150-200 lbs. /68-91 kg</td>
          </tr>
          <tr>
            <td className="p-3 border border-black">Waist Width</td>
            <td className="p-3 border border-black">246mm</td>
            <td className="p-3 border border-black">255mm</td>
          </tr>
          <tr>
            <td className="p-3 border border-black">Stance Width</td>
            <td className="p-3 border border-black">-40</td>
            <td className="p-3 border border-black">-40</td>
          </tr>
          <tr>
            <td className="p-3 border border-black">Binding Sizes</td>
            <td className="p-3 border border-black">
              Men&rsquo;s S/M, Women&rsquo;s S/M
            </td>
            <td className="p-3 border border-black">
              Men&rsquo;s L, Women&rsquo;s L
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

function ProductPrices({product}) {
  useEffect(() => {
    setTimeout(() => {
      const carlineElements = document.querySelectorAll('.product-top-price');

      carlineElements.forEach((element) => {
        let text = element.innerText;
        text = text.replace(/\$/g, '');
        element.innerText = text;
      });
    }, 100);
  }, []);

  const {selectedVariant} = useProductOptions();
  return (
    <div className="price-wrapper flex md:justify-start items-end md:pt-3 xs:border-t xs:flex-wrap">
      <div className="md:hidden xs:visible xs:w-full xs:block xs:text-sm">
        Precio:
      </div>

      <div className="mr-2 price-currency">MXN</div>
      <ProductPrice
        className="product-price product-top-price"
        variantId={selectedVariant.id}
        data={product}
      />
      {product.compareAtPriceRange.maxVariantPrice.amount != '0.0' &&
        product.compareAtPriceRange.maxVariantPrice.amount != '0.0' && (
          <ProductPrice
            className="sale-price"
            priceType="compareAt"
            variantId={selectedVariant.id}
            data={product}
          />
        )}
    </div>
  );
}

export default function ProductDetails({
  product,
  customer,
  sanityData,
  customerAccessToken,
  authorBoook,
}) {
  const initialVariant = product?.variants?.nodes[0];
  const [productInfo, setproductInfo] = useState({});
  const sizeChartMetafield = parseMetafield(product.meta_size_chart);
  const sustainableMetafield = parseMetafield(product.meta_sustainable);
  const lifetimeWarrantyMetafield = parseMetafield(
    product.meta_lifetime_warranty,
  );
  const [initialScrollKey, setInitialScrollKey] = useState(0);
  const [dataCarrousel, setDataCarrousel] = useState([]);
  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const [shapeImageVideo, setShapeImageVideo] = useState(false);
  const [isMovVideo, setIsMovVideo] = useState(false);
  const [openModalPdf, setOpenModalPdf] = useState(false);

  const cart = useCart();
  const onDocumentScroll = () => {
    setTimeout(() => {
      const scrollY = window.scrollY;
      const productDetails = document.querySelector('.product-detail-wrapper');
      const productDetailsHeight = productDetails.offsetHeight;
      const productDetailsTop = productDetails.offsetTop;
      const productDetailsTopOffset = productDetailsTop - scrollY;

      const productDetailsTopOffsetPercent =
        (productDetailsTopOffset / productDetailsHeight) * 100;

      if (productDetailsTopOffsetPercent <= 0) {
        setInitialScrollKey(productDetailsTopOffsetPercent);
      }
    }, 2000);
  };

  const handleSetItemToDataLayer = (product) => {
    sendEvent('select_item', {
      item_list_id: 1,
      item_list_name: 'product',
      ecommerce: {
        items: [
          {
            item_id: sanityData?.store?.id,
            item_name: sanityData?.store?.id,
            affiliation: '',
            currency: 'MXN',
            creative_name: '-',
            creative_slot: '',
            discount: discountValue(product),
            index: 0,
            item_brand: product?.vendor,
            item_category: sanityData?.tags ? sanityData?.tags[0]?.title : '', //Dynamic data
            item_category2: sanityData?.tags ? sanityData?.tags[1]?.title : '', //Dynamic data
            item_category3: sanityData?.tags ? sanityData?.tags[2]?.title : '', //Dynamic data
            item_category4: sanityData?.tags ? sanityData?.tags[3]?.title : '', //Dynamic data
            item_list_id: product.id,
            item_list_name: 'product',
            item_variant: '-',
            location_id: '-',
            price: sanityData?.store?.priceRange.maxVariantPrice,
            promotion_id: '-',
            promotion_name: '-',
            quantity: '1',
          },
        ],
      },
    });
  };

  useEffect(() => {
    handleSetItemToDataLayer(product);
  }, [initialScrollKey]);

  useEffect(() => {
    new KueskipayAdvertising().init();
  }, []);

  useEffect(() => {
    dataLayer.push({
      event: 'view_item', //Static data
      currency: 'MXN', //Dynamic data
      value: sanityData?.store?.priceRange.maxVariantPrice, //Dynamic data
      items: '', //Dynamic data
      item_id: sanityData?.store?.id, //Dynamic data
      item_name: sanityData?.store?.title, //Dynamic data
      affiliation: '', //Dynamic data
      coupon: '', //Dynamic data
      discount: '', //Dynamic data
      index: '0', //Dynamic data
      item_brand: product?.vendor, //Dynamic data
      item_category: sanityData.tags ? sanityData?.tags[0]?.title : '', //Dynamic data
      item_category2: sanityData.tags ? sanityData?.tags[1]?.title : '', //Dynamic data
      item_category3: sanityData.tags ? sanityData?.tags[2]?.title : '', //Dynamic data
      item_category4: sanityData.tags ? sanityData?.tags[3]?.title : '', //Dynamic data
      item_list_id: product.id, //Dynamic data
      item_list_name: '', //Dynamic data
      item_variant: product?.variants.nodes[0].title, //Dynamic data
      location_id: product.id, //Dynamic data
      price: sanityData?.store?.priceRange.maxVariantPrice, //Dynamic data
      quantity: '1', //Dynamic data
      // item_tag: sanityData?.label[0]?.title, //Dynamic data
      // item_tag2: sanityData?.label[1]?.title, //Dynamic data
      // item_tag3: sanityData?.label[2]?.title, //Dynamic data
      // item_tag4: sanityData?.label[3]?.title, //Dynamic data
    });
  });

  useEffect(() => {
    if (sanityData.modules) {
      setDataCarrousel({data: sanityData.modules});
    }
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', onDocumentScroll);
    return () => {
      document.removeEventListener('scroll', onDocumentScroll);
    };
  }, []);
  
  const discount = (product) => {
    if (product?.compareAtPriceRange?.maxVariantPrice?.amount) {
      let min = parseInt(product.priceRange.maxVariantPrice.amount);
      let max = parseInt(product.compareAtPriceRange.maxVariantPrice.amount);
      let discountPercent = Math.round(((max - min) / max) * 100);

      return roundDownToNearestTen(discountPercent);
    }
  };

  const discountValue = (product) => {
    let amount = product?.compareAtPriceRange?.maxVariantPrice?.amount;

    if (amount === '0.0' || amount === '0' || amount === 0) {
      return 0;
    }

    if (product?.compareAtPriceRange?.maxVariantPrice?.amount) {
      let min = parseInt(product.priceRange.maxVariantPrice.amount);
      let max = parseInt(product.compareAtPriceRange.maxVariantPrice.amount);
      return Math.abs(max - min);
    }

    return 0;
  };

  const labelDelibery = (sanityData)=>{
    // if(sanityData.store.options[0].values[0] === '9786075747538'){
    //   return 'Recíbelo a partir del 01 de abril';
    // }

    return 'Recíbelo en 8 días';
  }

  const openFragment = ()=>{
    sendPulseEvent('openFragment', {
      "originDisplayName": "pagina producto",
      "objectDisplayName": "Boton abrir fragmento",
      "targetDisplayName": "visor fragmentos",
      "product": product,
      "urlFragment": getBaseUrl()+'/producto/fragment?f='+encriptUrlData(sanityData?.bookExcerptUrl)
    });
  }

  useEffect(() => {
    if (sanityData?.imageVideoUpload) {
      getPropertiesImage(sanityData?.imageVideoUpload, (data) => {
        if (data.height > data.width) {
          setShapeImageVideo('VERTICAL');
        } else {
          setShapeImageVideo('HORIZONTAL');
        }
      });
    }

    if (
      sanityData?.embedVideo === 'Upload Video' &&
      sanityData?.embedVideoUpload
    ) {
      if (sanityData?.embedVideoUpload.indexOf('.mov') > -1) {
        setIsMovVideo(true);
      }
    }
  }, []);

  useEffect(() => {
    handleSetItemToDataLayer(product);
  }, [initialScrollKey]);

  useEffect(() => {
    new KueskipayAdvertising().init();
  }, []);

  useEffect(() => {
    dataLayer.push({
      event: 'view_item', //Static data
      currency: 'MXN', //Dynamic data
      value: sanityData?.store?.priceRange.maxVariantPrice, //Dynamic data
      items: '', //Dynamic data
      item_id: sanityData?.store?.id, //Dynamic data
      item_name: sanityData?.store?.title, //Dynamic data
      affiliation: '', //Dynamic data
      coupon: '', //Dynamic data
      discount: '', //Dynamic data
      index: '0', //Dynamic data
      item_brand: product?.vendor, //Dynamic data
      item_category: sanityData.tags ? sanityData?.tags[0]?.title : '', //Dynamic data
      item_category2: sanityData.tags ? sanityData?.tags[1]?.title : '', //Dynamic data
      item_category3: sanityData.tags ? sanityData?.tags[2]?.title : '', //Dynamic data
      item_category4: sanityData.tags ? sanityData?.tags[3]?.title : '', //Dynamic data
      item_list_id: product.id, //Dynamic data
      item_list_name: '', //Dynamic data
      item_variant: product?.variants.nodes[0].title, //Dynamic data
      location_id: product.id, //Dynamic data
      price: sanityData?.store?.priceRange.maxVariantPrice, //Dynamic data
      quantity: '1', //Dynamic data
    });

    sendPulseEvent('visitPdp', {
      "originDisplayName": "pagina de producto",
      "objectDisplayName": "producto",
      "sanityData": sanityData,
      "product": product
    });
  });

  useEffect(() => {
    if (sanityData.modules) {
      setDataCarrousel({data: sanityData.modules});
    }
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', onDocumentScroll);
    return () => {
      document.removeEventListener('scroll', onDocumentScroll);
    };
  }, []);


  return (
    <>
      <ProductOptionsProvider
        data={product}
        initialVariantId={initialVariant.id}
      >
        <article>
          <div>
            {dataCarrousel &&
              dataCarrousel?.data &&
              dataCarrousel.data.length > 0 && (
                <HeroCarousel sanity={dataCarrousel} />
              )}
          </div>
          <div className="product-detail-wrapper">
            <div className="md:container md:mx-auto flex xs:flex-col xs:p-5">
              <div className="md:hidden mt-5 mb-8 xs:hidden">
                <h1 className="text-4xl font-bold text-black mb-4">
                  {product.title}
                </h1>
                {product.vendor && (
                  <div className="text-sm font-medium mb-2 text-gray-900">
                    {product.vendor}
                  </div>
                )}
                <span />
                <div className="flex justify-between md:block">
                  {product && <ProductPrices product={product} />}
                </div>
              </div>
              <div className="product-main-wrapper md:container md:mx-auto flex xs:grid xs:grid-cols-2 xs:gap-4 xs:my-8 pt-4 xs:pb-0 xs:pt-0 xs:mt-0 xs:mb-0 xs:border-0 ">
                <div className="product-main-img md:w-3/12 md:p-5 xs:w-full">
                  {discount(product) >= 50 && (
                    <div className="tag-discount">
                      <span>- {discount(product)}%</span>
                    </div>
                  )}
                  <div className="relative">
                    {product?.productType == 'ebooks' && (
                      <>
                        <div className="badge-ebook bg-purple-120">eBook</div>
                      </>
                    )}
                    {product.featuredImage ? (
                      <Gallery product={product} sanityData={sanityData} />
                    ) : (
                      <div className="noImageWrapper">
                        <img
                          fetchpriority="high"
                          src="https://cdn.sanity.io/images/3bk3u1ri/production/62aedc89dd67e9685493f7f0d3ff168de30d837d-352x527.jpg"
                          className="w-full mx-auto h-full md:h-auto object-cover object-center flex-shrink-0 md:flex-shrink-none snap-start md:col-span-2 max-h-full"
                          alt={product.title}
                        />
                      </div>
                    )}
                  </div>
                  {sanityData?.bookExcerptUrl && (
                    <div className="mt-5 w-full excerpt-container hidde-phone">
                      <Link
                        to={'/producto/fragment?f='+encriptUrlData(sanityData?.bookExcerptUrl)}
                        className="read-excerpt-button"
                        target='blank'
                        onClick={()=>{openFragment()}}
                      >
                        <span>Leer fragmento</span>
                        <img src={excerptButton} />
                      </Link>
                    </div>
                  )}

                  {product?.productType == 'ebooks' && (  
                    <div className="mt-5 w-full excerpt-container hidde-phone">
                        <Link
                          to={'https://cdn.sanity.io/files/3bk3u1ri/production/c6afddee75dae5f585a280b469938ba63b5f4838.pdf'}
                          className="read-excerpt-button"
                          target='blank'
                        >
                          <span>Guía para leer eBooks</span>
                          <img src={excerptButton} />
                        </Link>
                    </div>
                  )}

                </div>
                <div className="md:w-5/12  md:p-5 xs:w-full">
                  <div className=" md:block">
                    <p className="product-title text-2xl font-semibold text-black mb-4">
                      {product.title}
                    </p>
                    <h1 className="product-title text-2xl font-semibold text-black mb-4 special-tag">
                      {product.title} - El Librero de Larousse
                    </h1>
                    <div id="product-st</div>ars">
                      <StarsFront reviews={sanityData?.reviews} />
                    </div>
                    {sanityData.store.options[0] && (
                      <div className="text-sm">
                        <span className="font-medium">ISBN: </span>
                        <span className="text-blue-55 font-medium">
                          {sanityData.store.options[0].values[0]}
                        </span>
                      </div>
                    )}
                    {product?.author?.value && (
                      <div className="text-sm">
                        <span className="font-medium"> Autor: </span>
                        <Link
                          to={'/search?q=' + product.author.value}
                          className="text-blue-55 underline font-medium"
                        >
                          {product.author.value}
                        </Link>
                      </div>
                    )}
                    {product?.language?.value && (
                      <div className="text-sm">
                        <span className="font-medium"> Idioma: </span>
                        <span className="text-blue-55 font-medium ">
                          {product.language.value}
                        </span>
                      </div>
                    )}
                    {product && <ProductPrices product={product} />}
                  </div>

                  <div className="tag-wrapper is-only-desktop">
                    {sanityData?.tags && (
                      <div className="w-full py-3 mt-1 xs:py-3 border-t border-b border-t-purple-50 md:mt-3 xs:pb-2 xs:border-b xs:gap-2 xs:flex xs:m-0 xs:flex-wrap xs:border-0">
                        {sanityData?.tags.map((tag) => {
                          return (
                            <Link
                              to={`/${
                                !tag.parent
                                  ? `categoria-producto/${tag?.slug?.current}`
                                  : !tag?.parent?.parent
                                  ? `categoria-producto/${tag.parent.slug.current}/${tag.slug.current}`
                                  : `categoria-producto/${tag.parent?.parent?.slug.current}/${tag.parent?.slug?.current}/${tag?.slug?.current}`
                              }`}
                              key={tag._id}
                              className="product-tag"
                            >
                              {changeGTSymbol(tag.name)}
                            </Link>
                          );
                        })}
                      </div>
                    )}
                    {sanityData?.label && (
                      <div className="py-3 w-full flex xs:gap-2 flex-wrap">
                        {sanityData?.label.map((tag) => {
                          return (
                            <Link
                              to={`/${
                                !tag.parent
                                  ? tag?.slug
                                    ? `etiqueta-producto/${tag.slug.current}`
                                    : `etiqueta-producto/`
                                  : !tag.parent.parent
                                  ? `etiqueta-producto/${tag.parent.slug.current}/${tag.slug.current}`
                                  : `etiqueta-producto/${tag.parent.parent.slug.current}/${tag.parent.slug.current}/${tag.slug.current}`
                              }`}
                              key={tag._id}
                              className="product-tag"
                            >
                              {changeGTSymbol(tag.title)}
                            </Link>
                          );
                        })}
                      </div>
                    )}

                    {product?.productType != 'ebooks' && (
                      <>
                        {product?.id !==
                          'gid://shopify/Product/8217305514238' && (
                          <div className="product-icon-details flex gap-4 my-4 xs:hidden .border-b-gray-80 border-b pb-4">
                            <div className="product-icon-details-delivery flex justify-left items-center">
                              <Image
                                src={delivery}
                                height={35}
                                width={35}
                                className="mr-2"
                                alt="Delivery"
                              />
                              <span className="font-medium text-sm leading-tight">
                                <div>{labelDelibery(sanityData)}</div>
                              </span>
                            </div>
                            {/* <div className="flex justify-center items-center">
                              <Image
                                src={gifts}
                                height={35}
                                width={35}
                                className="mr-2"
                                alt="Gifts"
                              />
                              <span className="text-sm font-medium leading-tight">
                                Regalos en todos tus pedidos
                              </span>
                            </div> */}
                          </div>
                        )}
                      </>
                    )}
                    {product?.productType == 'ebooks' && (
                      <>
                        <div className="ebook-disclaimer product-icon-details flex gap-4 mt-5 pb-3 xs:hidden border-b-gray-80 border-b">
                          <div className="flex justify-left items-center w-full">
                            <Image
                              src={iconEbook}
                              height={35}
                              width={35}
                              className="mr-2"
                              alt="Delivery"
                            />
                            <span className="text-sm leading-tight">
                              El acceso a tu Ebook tiene una vigencia de 12 meses
                              a partir de tu suscripción en la plataforma VitalSource
                            </span>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="xs:hidden md:visible">
                      {product?.productType != 'ebooks' && (
                        <div className="pt-0">
                          <kueskipay-widget
                            data-kpay-widget-type="product"
                            data-kpay-widget-font-size="15"
                            data-kpay-widget-text-align="left"
                            data-kpay-widget-amount={
                              product.priceRange.maxVariantPrice.amount
                            }
                            data-kpay-widget-product-name={product.title}
                          ></kueskipay-widget>
                        </div>
                      )}
                      <div className="pt-4">
                        <AddToCartMarkup
                          product={product}
                          sanityData={sanityData}
                          customerAccessToken={customerAccessToken}
                          className="xs:hidden md:visible"
                        />
                      </div>
                    </div>

                    <div className="flex  space-x-4">
                      {sustainableMetafield?.value && (
                        <span className="flex items-center mb-8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="stroke-current text-blue-600 mr-3"
                          >
                            <path
                              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364-.7071-.7071M6.34315 6.34315l-.70711-.70711m12.72796.00005-.7071.70711M6.3432 17.6569l-.70711.7071M16 12c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4 0-2.20914 1.79086-4 4-4 2.2091 0 4 1.79086 4 4Z"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span className="text-sm text-gray-900 font-medium">
                            Sustainable Material
                          </span>
                        </span>
                      )}
                      {lifetimeWarrantyMetafield?.value && (
                        <span className="flex items-center mb-8">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="stroke-current text-blue-600 mr-3"
                          >
                            <path
                              d="M9 12L11 14L15 10M20.6179 5.98434C20.4132 5.99472 20.2072 5.99997 20 5.99997C16.9265 5.99997 14.123 4.84453 11.9999 2.94434C9.87691 4.84446 7.07339 5.99985 4 5.99985C3.79277 5.99985 3.58678 5.9946 3.38213 5.98422C3.1327 6.94783 3 7.95842 3 9.00001C3 14.5915 6.82432 19.2898 12 20.622C17.1757 19.2898 21 14.5915 21 9.00001C21 7.95847 20.8673 6.94791 20.6179 5.98434Z"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span className="text-sm text-gray-900 font-medium">
                            Lifetime Warranty
                          </span>
                        </span>
                      )}
                    </div>
                  </div>

                  {sizeChartMetafield?.value && (
                    <div className="border-t border-gray-200">
                      <SizeChart />
                    </div>
                  )}
                </div>
                <div className="xs:hidden md:visible">
                  <ProductDetailsInfo
                    product={product}
                    productInfo={productInfo}
                    sanityData={sanityData}
                  />
                </div>
              </div>
              {product?.productType == 'ebooks' && (
                <>
                  <div className="ebook-disclaimer product-icon-details flex gap-4 pb-4 xs:visible md:hidden border-b-gray-80 border-b mb-5 mt-1-sm">
                    <div className="flex justify-left items-center w-full">
                      <Image
                        src={iconEbook}
                        height={35}
                        width={35}
                        className="mr-2"
                        alt="Delivery"
                      />
                      <span className="font-medium text-sm leading-tight text-11-sm">
                        El acceso a tu Ebook tiene una vigencia de 12 meses a
                        partir de tu suscripción en la plataforma VitalSource
                      </span>
                    </div>
                  </div>
                </>
              )}
              
              <div className="is-only-mobile fragment-mobile">
                <div className="w-full excerpt-container sm:pt-2 sm:pb-2">
                    <Link
                      to={'/producto/fragment?f='+encriptUrlData(sanityData?.bookExcerptUrl)}
                      className="read-excerpt-button read-excerpt-button-phone"
                      target='blank'
                    >
                      <span>Leer fragmento</span>
                      <img src={excerptButton} />
                    </Link>
                </div>
              </div>

              <div className="tag-wrapper is-only-mobile">
                {sanityData?.tags && (
                  <div className="w-full py-3 mt-1 xs:py-3 border-t border-b border-t-purple-50 md:mt-3 xs:pb-2 xs:border-b xs:gap-2 xs:flex xs:m-0 xs:flex-wrap xs:border-0">
                    {sanityData?.tags.map((tag) => {
                      return (
                        <Link
                          to={`/${
                            !tag.parent
                              ? `categoria-producto/${tag?.slug?.current}`
                              : !tag?.parent?.parent
                              ? `categoria-producto/${tag.parent.slug.current}/${tag.slug.current}`
                              : `categoria-producto/${tag.parent?.parent?.slug.current}/${tag.parent?.slug?.current}/${tag?.slug?.current}`
                          }`}
                          key={tag._id}
                          className="product-tag"
                        >
                          {changeGTSymbol(tag.name)}
                        </Link>
                      );
                    })}
                  </div>
                )}
                {sanityData?.label && (
                  <div className="py-3 w-full flex xs:gap-2 flex-wrap">
                    {sanityData?.label.map((tag) => {
                      return (
                        <Link
                          to={`/${
                            !tag.parent
                              ? tag?.slug
                                ? `etiqueta-producto/${tag.slug.current}`
                                : `etiqueta-producto/`
                              : !tag.parent.parent
                              ? `etiqueta-producto/${tag.parent.slug.current}/${tag.slug.current}`
                              : `etiqueta-producto/${tag.parent.parent.slug.current}/${tag.parent.slug.current}/${tag.slug.current}`
                          }`}
                          key={tag._id}
                          className="product-tag"
                        >
                          {changeGTSymbol(tag.title)}
                        </Link>
                      );
                    })}
                  </div>
                )}
                {product?.productType != 'ebooks' && (
                  <>
                    <div className="product-icon-details flex gap-4 my-4 xs:hidden .border-b-gray-80 border-b pb-4">
                      <div className="product-icon-details-delivery flex justify-left items-center">
                        <Image
                          src={delivery}
                          height={35}
                          width={35}
                          className="mr-2"
                          alt="Delivery"
                        />
                        <span className="font-medium text-sm leading-tight">
                          Recíbelo en 7 días
                        </span>
                      </div>
                      {/* <div className="flex justify-center items-center">
                        <Image
                          src={gifts}
                          height={35}
                          width={35}
                          className="mr-2"
                          alt="Gifts"
                        />
                        <span className="text-sm font-medium leading-tight">
                          Regalos en todos tus pedidos
                        </span>
                      </div> */}
                    </div>
                  </>
                )}
                {product?.productType == 'ebooks' && (
                  <>
                    <div className="ebook-disclaimer product-icon-details flex gap-4 mt-5 pb-3 xs:hidden border-b-gray-80 border-b">
                      <div className="flex justify-left items-center w-full">
                        <Image
                          src={iconEbook}
                          height={35}
                          width={35}
                          className="mr-2"
                          alt="Delivery"
                        />
                        <span className="text-sm leading-tight">
                          El acceso a tu Ebook tiene una vigencia de 12 meses a
                          partir de tu suscripción en la plataforma VitalSource
                        </span>
                      </div>
                    </div>
                  </>
                )}

                <div className="xs:hidden md:visible">
                  {product?.productType != 'ebooks' && (
                    <div className="pt-0">
                      <kueskipay-widget
                        data-kpay-widget-type="product"
                        data-kpay-widget-font-size="15"
                        data-kpay-widget-text-align="left"
                        data-kpay-widget-amount={
                          product.priceRange.maxVariantPrice.amount
                        }
                        data-kpay-widget-product-name={product.title}
                      ></kueskipay-widget>
                    </div>
                  )}
                  <div className="pt-4">
                    <AddToCartMarkup
                      product={product}
                      sanityData={sanityData}
                      customerAccessToken={customerAccessToken}
                      className="xs:hidden md:visible"
                    />
                  </div>
                </div>

                <div className="flex  space-x-4">
                  {sustainableMetafield?.value && (
                    <span className="flex items-center mb-8">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="stroke-current text-blue-600 mr-3"
                      >
                        <path
                          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364-.7071-.7071M6.34315 6.34315l-.70711-.70711m12.72796.00005-.7071.70711M6.3432 17.6569l-.70711.7071M16 12c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4 0-2.20914 1.79086-4 4-4 2.2091 0 4 1.79086 4 4Z"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="text-sm text-gray-900 font-medium">
                        Sustainable Material
                      </span>
                    </span>
                  )}
                  {lifetimeWarrantyMetafield?.value && (
                    <span className="flex items-center mb-8">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="stroke-current text-blue-600 mr-3"
                      >
                        <path
                          d="M9 12L11 14L15 10M20.6179 5.98434C20.4132 5.99472 20.2072 5.99997 20 5.99997C16.9265 5.99997 14.123 4.84453 11.9999 2.94434C9.87691 4.84446 7.07339 5.99985 4 5.99985C3.79277 5.99985 3.58678 5.9946 3.38213 5.98422C3.1327 6.94783 3 7.95842 3 9.00001C3 14.5915 6.82432 19.2898 12 20.622C17.1757 19.2898 21 14.5915 21 9.00001C21 7.95847 20.8673 6.94791 20.6179 5.98434Z"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="text-sm text-gray-900 font-medium">
                        Lifetime Warranty
                      </span>
                    </span>
                  )}
                </div>
              </div>

              <div className="xs:visible md:hidden">
                {product?.productType != 'ebooks' && (
                  <div className="text-center">
                    <kueskipay-widget
                      data-kpay-widget-type="product"
                      data-kpay-widget-font-size="15"
                      data-kpay-widget-text-align="left"
                      data-kpay-widget-amount={
                        product.priceRange.maxVariantPrice.amount
                      }
                      data-kpay-widget-product-name={product.title}
                    ></kueskipay-widget>
                  </div>
                )}
                <div className="w-full">
                  <div className="hidden product-notice text-2xl bg-red-40 text-white font-bold p-3 rounded-full text-center">
                    {' '}
                    ¡Quedan pocas unidades!{' '}
                  </div>
                  {product?.productType != 'ebooks' && (
                    <>
                      <div className="product-shipping-info grid gap-2 grid-cols-2 my-5 xs:pb-4 xs:border-b xs:mb-4">
                        <div className="flex justify-center items-center">
                          <Image
                            src={delivery}
                            height={50}
                            width={50}
                            alt="Delivery"
                            className="mr-2"
                          />
                          <label className="font-semibold">
                            {/* {sanityData.store.options[0].values[0] ===
                              '9786072127487' && (
                              <div>Recíbelo a partir del 17 de julio</div>
                            )} */}
                            {/* {sanityData.store.options[0].values[0] !==
                              '9786072127487' && <div>Recíbelo en 5 días</div>} */}
                              <div>{labelDelibery(sanityData)}</div>
                          </label>
                        </div>
                        {/* <div className="flex justify-center items-center">
                            <Image
                              src={gifts}
                              height={35}
                              width={35}
                              className="mr-2"
                              alt="Gifts"
                            />
                          <label className="font-semibold xs:font-medium">
                            Regalos en todos tus pedidos
                          </label>
                        </div> */}
                      </div>
                    </>
                  )}
                </div>
                <div className="w-full">
                  {
                    <ProductDetailsInfo
                      product={product}
                      productInfo={productInfo}
                      sanityData={sanityData}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="cart-mobile-wrapper xs:visible md:hidden fixed bottom-0 bg-white z-5 w-full">
            <AddToCartMarkup
              product={product}
              sanityData={sanityData}
              customerAccessToken={customerAccessToken}
            />
          </div>
          {authorBoook?.profile ? (
            <section className="product-description-wrapper md:mx-auto py-10 xs:pt-5 xs:mb-5 sinopsis-profile">
              <div className="container">
                <div class="lg:flex author-description">
                  <div class="lg:w-1/2 xs:w-full col">
                    <h2>Sinopsis</h2>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: `${product.descriptionHtml}`,
                      }}
                    />
                  </div>
                  <div class="lg:w-1/2 xs:w-full col col-author">
                    <h2>{authorBoook.name}</h2>
                    <div class="lg:flex profile">
                      <div class="lg:w-3/12 xs:w-full xs:mb-5">
                        <Image
                          src={authorBoook?.photo?.asset.url}
                          height={193}
                          width={255}
                          class="xs:w-full object-top"
                          alt=""
                        />
                      </div>
                      <div class="lg:w-9/12 xs:w-full profile-text">
                        {authorBoook.profile}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <section className="product-description-wrapper md:mx-auto py-10 xs:pt-5 xs:mb-5">
              <div className="container">
                <h2 className="section-title mb-4">Descripción</h2>
                <div className="product-description xs:px-4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `${product.descriptionHtml}`,
                    }}
                  />
                </div>
                {sanityData &&
                  sanityData.externalURL &&
                  sanityData.externalURLLabel && (
                    <div className="product-description-links mt-4">
                      <p>
                        <a
                          href={sanityData.externalURL}
                          target="_blank"
                          className="btn btn-primary btn-block btn-lg"
                          rel="noreferrer"
                        >
                          {sanityData.externalURLLabel}
                        </a>
                      </p>
                    </div>
                  )}
              </div>
            </section>
          )}
        </article>
        <section className="product-video-wrapper md:mx-auto py-10 xs:pt-5 xs:mb-5">
          <div className="text-center mb-1 text-blue-90 underline text-xl">
            <a href="https://www.clubhlm.com/" target='_blank'>
              Únete a                  
                <Image
                  src={ClubHLMLogo}
                  height={50}
                  width={50}
                  className="block inline mx-[7px]"
                />
              obtén beneficios y descuentos.
            </a>
          </div>
          <div className={`container video-book ${isMovVideo ? 'is-mov-video' : ''}`}>
            {sanityData?.embedVideo && (
              <>
                {sanityData?.embedVideo === 'Upload Video' && (
                  <>
                    <ModalVideo
                      channel={isMovVideo ? 'youtube' : 'custom'}
                      url={sanityData?.embedVideoUpload}
                      autoplay="true"
                      isOpen={isOpenVideo}
                      onClose={() => setIsOpenVideo(false)}
                    />
                    <div className="general-container-video">
                      <div
                        className={`video-image-container 
                            ${
                              shapeImageVideo === 'VERTICAL'
                                ? 'vertical-video'
                                : ''
                            }
                          `}
                        onClick={() => {
                          setIsOpenVideo(true);
                          setTimeout(() => {
                            const modalVideoWrap = document.querySelector(
                              '.modal-video-movie-wrap',
                            );
                            if (modalVideoWrap && isMovVideo) {
                              const iframe =
                                modalVideoWrap.querySelector('iframe');
                              if (iframe) {
                                const video = document.createElement('video');
                                video.src = sanityData?.embedVideoUpload;
                                video.width = iframe.width;
                                video.height = iframe.height;
                                video.controls = true;
                                modalVideoWrap.replaceChild(video, iframe);
                              }
                            }
                          }, 500);
                        }}
                      >
                        <img
                          src={sanityData?.imageVideoUpload}
                          className="image-front-page"
                        />
                        <img src={playButton} className="playButtonVideo" />
                      </div>
                    </div>
                  </>
                )}
                {sanityData?.embedVideo === 'Embed Youtube' && (
                  <iframe
                    width="560"
                    height="315"
                    src={
                      'https://www.youtube.com/embed/' +
                      sanityData?.embedYoutube
                    }
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                )}
                {sanityData?.embedVideo === 'Embed Ticktock' && (
                  <>
                    <iframe
                      src={
                        'https://www.tiktok.com/embed/v2/' +
                        sanityData?.embedTickTock
                      }
                      width="350px"
                      height="775px"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                  </>
                )}
              </>
            )}
          </div>
        </section>
      </ProductOptionsProvider>
    </>
  );
}
